const oopsibopGalleryControllers = new WeakMap();

function initOopsibopGallery(root = document) {
  root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const controller = new AbortController();
    oopsibopGalleryControllers.set(gallery, controller);
    const listen = (node, type, handler) => node?.addEventListener(type, handler, { signal: controller.signal });
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!main || thumbs.length < 1) return;
    let active = 0;
    let startX = null;

    function selectMedia(next) {
      active = (next + thumbs.length) % thumbs.length;
      const thumb = thumbs[active];
      main.src = thumb.dataset.fullSrc;
      main.alt = thumb.dataset.alt || '';
      thumbs.forEach((item, index) => {
        const selected = index === active;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-current', String(selected));
      });
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach((thumb, index) => listen(thumb, 'click', () => selectMedia(index)));
    listen(gallery.querySelector('[data-gallery-prev]'), 'click', () => selectMedia(active - 1));
    listen(gallery.querySelector('[data-gallery-next]'), 'click', () => selectMedia(active + 1));
    listen(gallery, 'keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); selectMedia(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); selectMedia(active + 1); }
    });
    listen(main, 'pointerdown', (event) => { if (event.pointerType !== 'mouse') startX = event.clientX; });
    listen(main, 'pointerup', (event) => {
      if (startX === null) return;
      const distance = event.clientX - startX;
      startX = null;
      if (Math.abs(distance) >= 45) selectMedia(active + (distance < 0 ? 1 : -1));
    });
  });
}

function unloadOopsibopGallery(root) {
  root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    oopsibopGalleryControllers.get(gallery)?.abort();
    oopsibopGalleryControllers.delete(gallery);
    delete gallery.dataset.initialized;
  });
}

document.addEventListener('DOMContentLoaded', () => initOopsibopGallery());
document.addEventListener('shopify:section:load', (event) => initOopsibopGallery(event.target));
document.addEventListener('shopify:section:unload', (event) => unloadOopsibopGallery(event.target));
